<h1>ABMP Continuing Education Transcript</h1>
<app-html-widget class="noprint" blocktitle="Transcript Intro"></app-html-widget>
<ng-container *ngIf="(userDetails$ | async) as user;">
  <p *ngIf="!user.IsLoggedIn">Please log in to view your transcript.</p>
  <ng-container *ngIf="user.IsLoggedIn && user.FullSSOData && user.FullSSOData.pac_sso">
    <app-license-update></app-license-update>
    <blockquote class="mt-4">
      {{user.FullSSOData.pac_sso.Columns.ind_full_name_cp}}<br />
      Member ID: {{user.FullSSOData.pac_sso.Columns.cst_recno}}<br />
      {{user.FullSSOData.pac_sso.Columns.adr_line1}}<br />
      {{user.FullSSOData.pac_sso.Columns.adr_city_state_code}}
    </blockquote>
    <div id="refreshalert">If your transcript isn't showing recently taken courses, please <a
        href="javascript: location.reload();">refresh</a>
      the page.</div>
    <ng-container
      *ngIf="(courses$ | async | courseStatusFilter:'CE Earned' | courseListSort:false:sortField:'userData.StartDate') as courses; else loading">
      <p *ngIf="courses.length == 0" class="noprint">No courses were found.</p>
      <ng-container *ngIf="courses.length > 0">
        <p class="noprint" *ngIf="sortField == 'title'">Sorting by course title - <a [routerLink]="null" class="sort"
            (click)="sortBy('userData.TranscriptDate')">sort by date issued instead</a>.</p>
        <p class="noprint" *ngIf="sortField == 'userData.TranscriptDate'">Sorting by issue date - <a [routerLink]="null"
            class="sort" (click)="sortBy('title')">sort by course title instead</a>.</p>
      </ng-container>
      <div *ngFor="let course of courses; let i = index;">
        <h4>{{course.title}}</h4>
        <a *ngIf="!course.archived_course" routerLink="/course/{{course.alias}}">View <ng-container
            *ngIf="!course.evaluated">or evaluate</ng-container> this course</a>
        <div class="d-flex">
          <a href="{{certificateBaseUrl}}{{course.netforum_course_id}}" target="_blank" title="View your CE certificate"
            class="text-dark mr-3">
            <img src="https://learn.cdn.abmp.com/public/ng/certificate.svg" class="mt-0" width="100" height="100" />
          </a>
          <div class="flex-grow-1">
            Instructor<ng-container *ngIf="course.authors.length > 1">s </ng-container>: <app-course-author-list
              [authors]="course.authors" [link]="false"></app-course-author-list><br />
            CE Hours: {{course.credits}}<br />
            <ng-container *ngIf="course.userData.TranscriptDate | dateFormat; else noTranscriptDate">
              Date Issued: {{course.userData.TranscriptDate | dateFormat:'FjY'}}
            </ng-container>
            <ng-template #noTranscriptDate><em>View course certificate for full details</em></ng-template>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>
</ng-container>

<ng-template #loading>
  <app-load-indicator description="load your course transcript"></app-load-indicator>
</ng-template>